"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledClose = exports.StyledIcon = exports.StyledModalContainer = exports.StyledModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = require("../../system/spacing.style");

var _colors = require("../../utils/colors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 1rem;\n  right: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition-duration: 0.5s;\n  color: ", ";\n  svg {\n    fill: ", ";\n    transition-duration: 0.5s;\n  }\n  &:hover {\n    cursor: pointer;\n    color: ", ";\n    svg {\n      fill: ", ";\n    }\n  }\n\n  @media screen and (min-width: ", ") {\n    top: 3rem;\n    right: 3rem;\n  }\n  @media screen and (min-width: ", ") {\n    top: 4rem;\n    right: 4rem;\n  }\n  @media screen and (min-width: ", ") {\n    top: 3.5rem;\n    right: 3.5rem;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 1rem;\n  padding-top: 0.1rem;\n  @media screen and (min-width: ", ") {\n    padding-top: 0;\n  }\n  @media screen and (min-width: ", ") {\n    padding-top: 0.2rem;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  max-width: 1000px;\n  padding: ", ";\n  ", "\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100vw;\n  height: 100vh;\n  overflow: scroll;\n  background: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: ", ";\n  backdrop-filter: blur(5px);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var CloseIcon = function CloseIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), _react.default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var StyledModal = _styledComponents.default.div(_templateObject(), function (props) {
  return props.bgColor ? (0, _colors.getRGBOpacity)(props.bgColor, 0.95) : (0, _colors.getRGBOpacity)((0, _colors.normaliseColor)(props.theme.modal.background, props.theme), 0.95);
}, function (props) {
  return props.zIndex ? props.zIndex : props.theme.modal.zIndex;
});

exports.StyledModal = StyledModal;

var StyledModalContainer = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.theme.modal.padding;
}, function (props) {
  return (0, _spacing.spacingStyle)(props.theme, props.padding, props.inset);
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.modal.textColor, props.theme);
});

exports.StyledModalContainer = StyledModalContainer;
var StyledIcon = (0, _styledComponents.default)(CloseIcon)(_templateObject3(), function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.lg;
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.xl;
});
exports.StyledIcon = StyledIcon;

var StyledClose = _styledComponents.default.div(_templateObject4(), function (props) {
  return (0, _colors.normaliseColor)(props.theme.modal.closeButton.color, props.theme);
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.modal.closeButton.color, props.theme);
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.modal.closeButton.hoverColor, props.theme);
}, function (props) {
  return (0, _colors.normaliseColor)(props.theme.modal.closeButton.hoverColor, props.theme);
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.sm;
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.lg;
});

exports.StyledClose = StyledClose;